import { onClick, onSubmit, Popover } from '@nx-paeonia/utils-events';
import { signal } from '@nx-paeonia/utils-signals';
import { animate, AnimationSequence, scroll, stagger } from 'motion';

const isLanguageListOpen = signal(true);
const isCountryListOpen = signal(false);

isLanguageListOpen.subscribe((isOpen) => {
  if (isOpen) {
    const animationSequence: AnimationSequence = [
      ["#localization_form [data-popover-trigger='LanguageList'] svg", { scaleY: [-1, 1] }],
      ['#localization_form #LanguageList', { scaleY: [0, 1], opacity: [0, 1], translateY: [10, 0] }, { at: '<' }],
      ['#localization_form li', { opacity: [0, 1] }, { delay: stagger(0.05) }],
    ];

    animate(animationSequence);
  } else {
    const animationSequence: AnimationSequence = [
      ['#localization_form li', { opacity: [1, 0] }, { delay: stagger(0.05) }],
      ["#localization_form [data-popover-trigger='LanguageList'] svg", { scaleY: [1, -1] }, { at: '<' }],
      ['#localization_form #LanguageList', { scaleY: [1, 0], opacity: [1, 0], translateY: [0, 10] }],
    ];

    animate(animationSequence);
  }
});

onSubmit(
  '#localization_form',
  (_, form: HTMLElement) => {
    console.log(form);
  },
  { preventDefault: true }
);

onClick(
  '#localization_form a[href="#"]',
  (_, link: HTMLElement) => {
    const isCurrent = link.getAttribute('aria-current') === 'true';
    if (isCurrent) {
      return;
    }

    const target = link.getAttribute('data-target');
    if (!target) {
      return;
    }
    const targetElement = document.querySelector<HTMLInputElement>(target);
    if (!targetElement) {
      return;
    }

    targetElement.value = link.getAttribute('data-value') || '';

    targetElement.closest('form')?.submit();
  },
  { preventDefault: true }
);

onClick('#localization_form [data-popover-trigger="LanguageList"]', () => {
  isLanguageListOpen.update((c) => !c);
});

function _initPopovers() {
  const popover = new Popover({
    boundaryPadding: 8,
    offset: 8,
    preferredPosition: 'bottom',
  });

  const languagePopover = document.querySelector<HTMLElement>('#localization_form #LanguageList');
  const languageTrigger = document.querySelector<HTMLElement>('#localization_form [data-popover-trigger="LanguageList"]');

  if (languagePopover && languageTrigger) {
    popover.autoUpdate(languagePopover, languageTrigger);
    popover.position(languagePopover, languageTrigger);

    isLanguageListOpen.subscribe(() => {
      popover.position(languagePopover, languageTrigger);
    });
  }

  const countryPopover = document.querySelector<HTMLElement>('#localization_form #CountryList');
  const countryTrigger = document.querySelector<HTMLElement>('#localization_form [data-popover-trigger="CountryList"]');

  if (countryPopover && countryTrigger) {
    popover.autoUpdate(countryPopover, countryTrigger);
    popover.position(countryPopover, countryTrigger);

    isCountryListOpen.subscribe(() => {
      popover.position(countryPopover, countryTrigger);
    });
  }

  scroll(() => {
    isLanguageListOpen.update(() => false);
    isCountryListOpen.update(() => false);
  });

  isLanguageListOpen.update(() => false);
  isCountryListOpen.update(() => false);
}

_initPopovers();
